import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  PreliminaryRiskAssessment,
  PreliminaryRiskAssessmentCreateRequest,
  PreliminaryRiskAssessmentCreateResponse,
  PreliminaryRiskAssessmentDetails,
  PreliminaryRiskAssessmentUpdateRequest,
  PreliminaryRiskAssessmentUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class PreliminaryRiskAssessmentService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/preliminary-risk-assessments/';
  }


  setPriority(id: number, request: PriorityPatchRequest): Observable<PreliminaryRiskAssessment> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<PreliminaryRiskAssessment>(url, request);
  }

  public getPreliminaryRiskAssessments(): Observable<PreliminaryRiskAssessment[]> {
    const url = this.endpoint;
    return this.httpClient.get<PreliminaryRiskAssessment[]>(url);
  }

  public getPreliminaryRiskAssessmentsById(id: number): Observable<PreliminaryRiskAssessment> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<PreliminaryRiskAssessment>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public deletePreliminaryRiskAssessment(id: number): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<void>(url);
  }

  public createPreliminaryRiskAssessment(requestBody: PreliminaryRiskAssessmentCreateRequest): Observable<PreliminaryRiskAssessmentCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<PreliminaryRiskAssessmentCreateResponse>(url, requestBody);
  }

  public updatePreliminaryRiskAssessment(id: number, requestBody: PreliminaryRiskAssessmentUpdateRequest)
    : Observable<PreliminaryRiskAssessmentUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<PreliminaryRiskAssessmentUpdateResponse>(url, requestBody);
  }

  public getPreliminaryRiskAssessmentDetails(id: number): Observable<PreliminaryRiskAssessmentDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<PreliminaryRiskAssessmentDetails>(url);
  }

  // public updateUserColumns(request: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, request);
  // }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
